import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'
import update from 'immutability-helper'

const initialState = {
  users: [],
  tableView: {},
  tableViewList: [],
  proposalReviewers: []
}

const usersReducer = createReducer(initialState, {
  [ACT.USERS_FETCH_SUCCESS](state, action) {
    const { users } = action.payload
    return {
      ...state,
      users
    }
  },

  [ACT.TABLE_VIEWS_LIST_FETCH_SUCCESS](state, action) {
    const { tableViewList } = action.payload
    return {
      ...state,
      tableViewList
    }
  },

  [ACT.TABLE_VIEWS_SAVE_SUCCESS](state, action) {
    const { tableView } = action.payload
    const index = state.tableViewList.findIndex(list => list.label === tableView.label)

    if (~index) {
      return update(state, {
        tableViewList: {
          [index]: { $set: tableView }
        }
      })
    }

    return update(state, {
      tableViewList: { $push: [tableView] }
    })
  },

  [ACT.TABLE_VIEW_DELETE_SUCCESS](state, action) {
    const { id } = action.payload
    const index = state.tableViewList.findIndex(list => list.value === id)
    return update(state, {
      tableViewList: { $splice: [[index, 1]] },
      tableView: { $set: {} }
    })
  },

  [ACT.TABLE_VIEWS_LIST_RESET](state) {
    return update(state, {
      tableView: { $set: {} }
    })
  },

  [ACT.TABLE_VIEW_FETCH_SUCCESS](state, action) {
    const { tableView } = action.payload
    return {
      ...state,
      tableView
    }
  },

  [ACT.PROPOSAL_REVIWEWERS_FETCH_SUCCESS](state, action) {
    const { proposalReviewers } = action.payload
    return {
      ...state,
      proposalReviewers
    }
  }
})

export default usersReducer
